import {
  PRE_REGISTER_SIM_GIFT_DALEFON_ERROR,
  PRE_REGISTER_SIM_GIFT_DALEFON,
} from '_models/redux/types';
import axiosTokenInstance from 'services/api/backoffice';

export const preRegisterGiftSimDalefonAction = (csvFile, productId) => async (dispatch) => {
  const url = `/api/orders/pre-register`;

  try {
    const formData = new FormData();
    formData.append('product_id', productId);
    formData.append('file', csvFile);

    const response = await axiosTokenInstance.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    const { data, status } = response || {};

    dispatch({
      method: 'put',
      payload: data || {},
      status: status || null,
      type: PRE_REGISTER_SIM_GIFT_DALEFON,
    });
  } catch (e) {
    console.error(e);
    dispatch({
      method: 'put',
      payload: e || {},
      status: e?.response?.status || null,
      type: PRE_REGISTER_SIM_GIFT_DALEFON_ERROR,
    });
    throw e;
  }
};
